import React from 'react';
import { Phone } from 'lucide-react';
import { useSelector } from 'react-redux';
import { getCourier, getCourierSetting } from '../state/courierSlice';
import { RootState } from '../store';

const ContactUs = () => {
  const courier = useSelector(getCourier);
  const courierSettings = useSelector((state: RootState) => getCourierSetting(state));
  const contactInfo = courierSettings?.contactInformation;
  const storeAddress = courierSettings?.storeAddress;
  // console.log('courier', courier);
  // console.log('courierSettings', courierSettings);
  // console.log('contactInfo', contactInfo);
  // console.log('storeAddress', storeAddress);
  return (
    <div className="flex flex-col min-h-screen bg-white dark:bg-gray-900">
      {/* Header with blue background to match app style */}
      <div className="bg-primary dark:bg-blue-600 text-white">
        <div className="p-4">
          {/* Phone Icon */}
          <div className="flex justify-center mt-4 mb-6 pb-6">
            <div className="h-20 w-20 rounded-full bg-white/40 flex items-center justify-center">
              <Phone className="h-10 w-10 text-white" />
            </div>
          </div>
        </div>
      </div>
      {/* Message */}
      <p className="text-gray-700 dark:text-gray-300 text-center py-4 bg-gray-50 dark:bg-gray-800">
        Feel free to reach out
      </p>
      {/* Contact Information */}
      <div className="bg-white dark:bg-gray-900 flex-1">
        {/* Email */}
        {courier?.email && (
          <div className="p-4 border-b border-gray-200 dark:border-gray-700">
            <h2 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
              Email
            </h2>
            <p className="text-gray-900 dark:text-white">{courier.email}</p>
          </div>
        )}
        {/* Mobile Phone */}
        {contactInfo?.mobilePhone && (
          <div className="p-4 border-b border-gray-200 dark:border-gray-700">
            <h2 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
              Mobile Phone
            </h2>
            <p className="text-gray-900 dark:text-white">{contactInfo.mobilePhone}</p>
          </div>
        )}
        {/* Address */}
        {storeAddress && (
          <div className="p-4 border-b border-gray-200 dark:border-gray-700">
            <h2 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
              Address
            </h2>
            {storeAddress.street1 && (
              <p className="text-gray-900 dark:text-white">{storeAddress.street1}</p>
            )}
            {storeAddress.city && (
              <p className="text-gray-900 dark:text-white">{storeAddress.city}</p>
            )}
            {storeAddress.state && (
              <p className="text-gray-900 dark:text-white">{storeAddress.state}</p>
            )}
            {storeAddress.country && (
              <p className="text-gray-900 dark:text-white">{storeAddress.country}</p>
            )}
          </div>
        )}
        {/* Additional Contact Info */}
        {contactInfo?.mobilePhone && (
          <div className="p-4 border-b border-gray-200 dark:border-gray-700">
            <h2 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
              WhatsApp
            </h2>
            <p className="text-gray-900 dark:text-white">{contactInfo.mobilePhone}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactUs;